var map = {
	"./bg-standby-green.svg": "80d9",
	"./fingerprint.svg": "db93",
	"./folder-open-solid.svg": "8fd2",
	"./icon-open-menu.svg": "aa48",
	"./loader.svg": "1572",
	"./location-pin.svg": "90f4",
	"./logo-black.svg": "fec44",
	"./logo-icon.svg": "4422",
	"./phone.svg": "aaed",
	"./select-filter.svg": "c888",
	"./split-arrow.svg": "e1dc",
	"./store-logo.svg": "edbc",
	"./warning.svg": "2bc6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "aa35";